<template>
  <div style="width: 100%">
    <div class="first-spacer">
      <FadeCarousel ref="fade_carousel" :images="newList" />
      <div class="linear-gradient top"></div>
      <div class="linear-gradient bottom"></div>
      <div class="content-wrapper">
        <div class="left">
          <transition name="fromtop" appear>
            <div class="date">
              <span class="day">{{
                handleDate(newList[0].pub_date, "dd")
              }}</span>
              <span class="month">{{
                handleDate(newList[0].pub_date, "mmmm")
              }}</span>
            </div>
          </transition>
          <transition name="fromtop" appear>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: newList[0].url },
                })
              "
              class="category"
            >
              <span class="cat">{{ newList[0].sub_category.name }}</span>
            </router-link>
          </transition>
          <transition name="fromleft" appear>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: newList[0].url },
                })
              "
              class="title"
            >
              {{ newList[0].title }}
            </router-link>
          </transition>
          <div style="display: flex">
            <transition name="fromleft" appear>
              <router-link
                :to="
                  $i18nRoute({
                    name: 'NewsDetail',
                    params: { slug: newList[0].url },
                  })
                "
                class="flat-btn"
              >
                {{ $t("main.more") }}
              </router-link>
            </transition>
          </div>
          <div class="next-news-swap">
            <div class="next-btn" @click="handleNewsChange(-1)">
              <i class="fad fa-chevron-left"></i>
            </div>
            <div
              class="next-btn"
              style="margin-left: 64px"
              @click="handleNewsChange(1)"
            >
              <i class="fad fa-chevron-right"></i>
            </div>
            <transition-group name="swap" appear>
              <template v-for="item in newList.slice(1, 3)" :key="item.id">
                <router-link
                  :to="
                    $i18nRoute({
                      name: 'NewsDetail',
                      params: { slug: item.url },
                    })
                  "
                  class="child-article"
                >
                  <div class="progress-wrapper">
                    <div class="progress"></div>
                  </div>
                  <div class="category">
                    <span class="cat">{{ item.sub_category.name }}</span>
                    <!-- <span class="sub-cat">Subcategory</span> -->
                  </div>
                  <div style="--snup: 4" class="title limited-text">
                    {{ item.title }}
                  </div>
                </router-link>
              </template>
            </transition-group>
          </div>
        </div>
        <div class="center">
          <div>
            <a
              href="https://t.me/zamon_broadcaster_bot"
              target="_blank"
              class="write-article"
            >
              <svg
                width="98"
                height="106"
                viewBox="0 0 98 106"
                class="feather"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.73241 101.563L7.1471 95.9127L3.24598 94.3726L0.566312 98.7888C0.566312 98.7888 2.04371 102.796 0.402832 105.999C0.404112 106 2.45737 102.502 5.73241 101.563ZM3.11161 98.9702C3.59181 98.7734 4.14528 98.998 4.34363 99.4696C4.54358 99.9411 4.31579 100.484 3.83559 100.681C3.35539 100.878 2.80193 100.653 2.60357 100.181C2.4017 99.7079 2.62981 99.165 3.11161 98.9702Z"
                />
                <path
                  d="M46.6604 36.0299C35.4263 45.2437 20.7192 64.2227 8.24639 86.393L8.23935 86.3843L6.05908 90.2317L8.38395 91.1262L9.61245 87.8896C16.2665 75.8954 34.3181 44.5722 67.3254 23.7609C67.3254 23.7609 79.6139 16.4421 91.7213 6.32007C88.7736 8.78411 82.9584 11.8726 79.8052 13.8651C71.5295 19.0939 61.3169 24.0079 46.6604 36.0299Z"
                />
                <path
                  d="M6.62153 68.9C4.06695 77.9291 4.21316 84.8058 5.20172 86.6956H6.74694C11.0137 77.8578 31.5639 45.8438 44.355 35.8229C57.6075 25.4399 67.8302 19.3985 76.4281 14.9925C79.4472 13.4457 82.5444 11.3505 85.3373 9.25022C88.7288 6.57567 92.167 3.71493 95.1775 0.915296L86.451 6.63838L90.3419 0.687192L82.9133 8.24087L87.7473 0C76.3114 1.03175 65.6989 6.75323 65.6989 6.75323C61.4532 11.7891 58.0339 19.8003 58.0339 19.8003C57.9155 15.7945 60.6285 9.72882 60.6285 9.72882C58.6239 10.6441 51.0075 14.9944 51.0075 14.9944C47.282 18.0849 46.1248 26.2109 46.1248 26.2109C45.4165 23.0056 47.8927 16.8266 47.8927 16.8266C37.1616 23.0075 29.4966 33.5364 29.4966 33.5364C24.191 43.9509 28.5534 52.0769 26.902 50.1314C25.2506 48.186 25.6057 41.0901 25.6057 41.0901C14.403 51.8491 13.225 56.9979 13.225 56.9979C11.3388 61.576 9.68734 73.8226 9.68734 73.8226C8.62584 72.6776 9.68734 66.2689 9.68734 66.2689C6.97472 71.992 8.27265 77.3705 8.27265 77.3705C6.97632 76.9114 6.62153 68.9 6.62153 68.9Z"
                />
                <path
                  d="M95.1787 4.54004C95.1787 4.54004 90.8652 8.71982 85.3386 12.875C76.6748 19.7082 68.3328 25.294 68.3328 25.294C35.6525 44.6051 17.4425 76.1197 11.4238 86.9253H14.6237C15.7546 86.0187 17.4531 85.335 24.5457 83.2817C33.5071 80.6872 38.8526 75.2706 38.8526 75.2706C38.8526 75.2706 30.6777 79.8487 26.8252 79.3912C22.9727 78.9337 17.796 80.3829 17.796 80.3829C17.796 80.3829 15.8192 79.4676 25.5672 78.0181C35.3153 76.5685 51.3517 65.6582 51.3517 65.6582C51.3517 65.6582 45.2197 68.176 42.3903 67.9463C39.5609 67.7166 32.5643 67.9463 32.5643 67.9463C37.2015 66.8778 41.5256 67.4888 48.6007 64.8178C55.6757 62.1468 55.2825 62.3765 55.2825 62.3765C63.3007 59.7054 66.6314 51.3897 66.6314 51.3897C65.2446 51.924 54.6526 53.2203 50.2591 51.924C45.8653 50.6277 38.3798 51.924 38.3798 51.924C45.4549 49.5591 47.0279 50.6277 48.7558 50.5512C50.4853 50.4747 56.0676 50.9322 67.152 47.1181C78.2363 43.304 81.3805 38.5727 81.3805 38.5727L73.9052 39.5715C78.7862 38.7502 84.2882 35.5206 84.2882 35.5206C80.9073 36.4359 75.6401 36.8934 75.6401 36.8934C81.8504 35.5206 85.3098 33.6132 85.3098 33.6132C91.1269 29.1881 92.4632 22.6265 92.4632 22.6265C84.2083 25.4488 77.6847 24.1525 77.6847 24.1525C89.0058 23.3905 92.15 20.4897 93.7211 19.8041C95.2942 19.117 95.9414 16.2754 95.9414 16.2754C90.2218 18.3357 83.7364 18.6783 83.7364 18.6783C90.7523 17.5909 96.7642 14.0427 96.7642 14.0427V10.4909C94.0516 12.0361 89.2784 13.2384 89.2784 13.2384L96.7066 8.43221C97.1242 6.02768 95.1787 4.54004 95.1787 4.54004Z"
                />
                <path
                  d="M3.53467 92.9601L7.95279 94.7299L8.77563 92.7739L4.35783 91.0044L3.53467 92.9601Z"
                />
                <path
                  d="M52.6379 91.3242C38.0405 98.342 24.017 103.125 5.36688 103.752C3.62682 103.811 3.61818 105.551 5.36688 105.492C22.0508 104.932 35.9332 101.345 49.3213 95.0705C64.2354 88.0789 77.9334 82.2202 96.6146 80.2293C98.3374 80.0447 97.6048 78.3693 95.8942 78.552C79.3497 80.3167 65.9076 84.9453 52.6379 91.3242Z"
                />
              </svg>
              <div class="text">{{ $t("main.appeal") }} !</div>
              <div class="hint">
                {{ $t("main.appeal_content") }}
              </div>
            </a>
          </div>
        </div>
        <div class="right">
          <div>
            <LiveStreamWindow />
          </div>
          <div class="news-scroller">
            <transition-group name="height">
              <template v-for="item in newList.slice(3, 10)" :key="item.id">
                <router-link
                  :to="
                    $i18nRoute({
                      name: 'NewsDetail',
                      params: { slug: item.url },
                    })
                  "
                  class="news-scroll-elem"
                >
                  <div class="title limited-text" style="--snup: 3">
                    {{ item.title }}
                  </div>
                  <div class="meta">
                    <!-- <div class="author">Ivan Ivanov</div> -->
                    <div class="date">
                      {{ handleDate(item.pub_date, "dd mmmm") }}
                    </div>
                  </div>
                  <!-- <div class="news-scroll-elem-divider"></div> -->
                </router-link>
              </template>
            </transition-group>
          </div>
          <div>
            <div class="news-scroller-spacer"></div>
          </div>
        </div>
      </div>
      <div class="collar-wrapper">
        <div class="collar-spacer"></div>
        <div class="collar">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url },
              })
            "
            class="collar-item"
            v-for="item in newList.slice(10, 13)"
            :key="item.id"
          >
            <div class="img-block">
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div style="height: auto">
              <div class="collar-sub-cat">{{ item.sub_category.name }}</div>
              <div class="collar-title limited-text" style="--snup: 3">
                {{ item.title }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FadeCarousel from "@/components/FadeCarousel";
import ImageContainer from "@/components/ImageContainer";
import LiveStreamWindow from "@/components/LiveStreamWindow";
import { useFormatter } from "@/utils/formatter";
import { onBeforeUnmount, onMounted, ref } from "vue";

export default {
  name: "DefaultMainBar",
  components: {
    FadeCarousel,
    LiveStreamWindow,
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const newList = ref(props.list ?? []);
    const { moveArrayItemToNewIndex } = useFormatter();

    const handleNewsChange = (dir = 1) => {
      if (dir === 1) {
        newList.value = moveArrayItemToNewIndex(
          newList.value,
          0,
          newList.value.length - 1
        );
      } else {
        newList.value = moveArrayItemToNewIndex(
          newList.value,
          newList.value.length - 1,
          0
        );
      }
    };

    let mainInterval;
    onMounted(() => {
      mainInterval = setInterval(handleNewsChange, 5000);
    });

    onBeforeUnmount(() => {
      if (mainInterval) clearInterval(mainInterval);
    });

    return {
      newList,
      handleNewsChange,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.height-enter-active {
  opacity: 0;
  transition: all 1s;
}
.height-leave-active {
  position: absolute;
  transition: transform 1s, opacity 0.4s;
}
.height-leave-to {
  opacity: 0;
  position: absolute;
  transform: translateY(-30px);
}

.swap-enter-active,
.swap-leave-active {
  transition: all 0.6s;
}

.swap-enter-from {
  width: 0 !important;
}

.swap-leave-to {
  opacity: 0;
  width: 0 !important;
  transform: translateX(-100%);
}
.swap-move {
  transition: transform 1s;
}

@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
  .write-article {
    background-color: rgba(var(--primary-bg), 0.6);
  }
  .content-wrapper {
    .right {
      .news-scroller {
        .news-scroll-elem {
          background-color: rgba(var(--primary-bg), 0.4);
        }
      }
    }
  }
}

.first-spacer {
  position: relative;
  width: 100%;
  height: 100vh;
  max-height: 1500px;
}

.linear-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  &.top {
    background-image: linear-gradient(var(--background-color), transparent);
    opacity: 0.2;
  }

  &.bottom {
    background-image: linear-gradient(transparent, var(--background-color));
  }
}

.content-wrapper {
  --top-offset: calc(max(145px, 9vw));
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: var(--top-offset);
  width: var(--width-content);
  height: calc(100% - var(--top-offset));
  display: flex;

  .left {
    // width: var(--left-width);
    width: 40%;
    height: 100%;
    color: var(--primary-font-color);
    font-family: Open Sans;
    display: flex;
    flex-direction: column;

    .date {
      .day {
        font-size: 3em;
      }

      .month {
        font-size: 1.75em;
        padding-left: 0.5em;
        text-transform: lowercase;
      }
    }

    .category {
      text-transform: uppercase;
      padding-top: 1.25em;

      .cat {
        font-weight: 600;
        font-size: 1.125em;
        transition: all 0.2s ease;

        margin-right: 1.25em;
        cursor: pointer;

        &:hover {
          color: rgba(var(--secondary-bg), 0.7);
        }
      }

      .sub-cat {
        transition: all 0.2s ease;
        cursor: pointer;

        &:hover {
          color: rgba(var(--secondary-bg), 0.7);
        }
      }
    }

    .title {
      padding: 1.875rem 0;
      letter-spacing: 0.05em;
      font-size: 2.5em;
      cursor: pointer;
      transition: all 0.2s ease;
      font-family: "Roboto", serif;

      // &::first-letter {
      //   font-style: italic;
      //   font-size: 1.1em;
      // }

      &:hover {
        color: rgba(var(--secondary-bg), 0.7);
      }
    }

    .next-news-swap {
      position: relative;
      width: 100%;
      height: 200px;
      display: flex;
      margin-top: auto;
      overflow: visible;
      white-space: nowrap;

      .next-btn {
        position: absolute;
        top: -70px;
        left: 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid var(--primary-font-color);
        color: var(--primary-font-color);
        font-size: 1.8em;
        width: 45px;
        height: 45px;
        transition: all 0.4s;

        &:hover {
          background-color: var(--foreground-color);
          color: var(--secondary-font-color);
        }
      }

      .child-article {
        width: 50%;
        height: 100%;
        cursor: pointer;

        .progress-wrapper {
          height: 4px;
          width: 40px;
          position: relative;
          background-color: rgba(var(--primary-bg), 0.2);

          .progress {
            position: absolute;
            top: 0;
            height: 100%;
            left: 0;
            width: 0;
            background-color: var(--foreground-color);
            animation: progress-filler 4.6s linear forwards;
          }
        }

        .category {
          text-transform: uppercase;
          padding-top: 1.25rem;
          font-size: 1rem;

          .cat {
            font-weight: 600;
            transition: all 0.2s ease;

            margin-right: 1em;
            cursor: pointer;

            &:hover {
              color: rgba(var(--secondary-bg), 0.7);
            }
          }

          .sub-cat {
            transition: all 0.2s ease;
            cursor: pointer;

            &:hover {
              color: rgba(var(--secondary-bg), 0.7);
            }
          }
        }

        .title {
          font-weight: 400;
          font-size: 1.625em;
          width: 100%;
          line-height: 1.18em;
          height: auto;
          padding: 0.4rem 1rem 0rem 0;
          white-space: normal;
          // margin-right: 0.8em;
        }
      }
    }
  }
  .right {
    --right-width: 368px;
    width: var(--right-width);
    margin-left: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    .news-scroller {
      width: 100%;
      margin-top: 1.625rem;
      overflow-y: scroll;
      overflow-x: hidden;
      &-spacer {
        width: 100%;
        height: 135px;
      }
      &::-webkit-scrollbar {
        width: 0.375rem;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: hsla(0, 0%, 30%, 0.7);
        border-radius: 8px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: hsla(0, 0%, 50%, 0.8);
      }
      .news-scroll-elem {
        padding-top: 7px;
        padding-bottom: 12px;
        padding-left: 12px;
        padding-right: 12px;
        margin-bottom: 12px;
        border: 1px var(--foreground-color) solid;
        border-radius: 4px;
        backdrop-filter: blur(12px);
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--primary-font-color);
        transition: all 0.4s ease;
        width: calc(var(--right-width) - 32px);
        &:hover {
          color: rgba(var(--secondary-bg), 0.7);
        }
        .title {
          font-size: 1.375em;
          line-height: 1.27em;
          width: 100%;
          font-family: Roboto;
        }
        .author {
          font-weight: 500;
          font-style: italic;
        }
        .meta {
          display: flex;
          padding-top: 1rem;
          width: 100%;
          justify-content: space-between;
        }
        // .news-scroll-elem-divider {
        //   width: 65%;
        //   height: 1px;
        //   margin: 16px 0;
        //   background-color: var(--foreground-color);
        //   opacity: 0.4;
        // }
      }
    }
  }
  .center {
    flex: 1 0 0;
    position: relative;
    font-family: Open Sans;
    display: flex;
    justify-content: flex-end;
    transition: all 0.4s ease;

    div,
    svg {
      transition: all 0.3s ease;
    }

    .write-article {
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding: 0.5rem 1rem;
      line-height: 1em;
      width: 6vw;
      height: auto;
      border: 1px solid var(--primary-font-color);
      border-radius: 4px;
      margin-right: 0.8rem;
      fill: var(--primary-font-color);
      cursor: pointer;
      position: relative;
      backdrop-filter: blur(4px);
      background-color: var(--seethrough-bg);

      .feather {
        padding: 0.5rem 0.9rem;
      }

      .text {
        text-align: center;
        font-size: 0.875em;
        padding-bottom: 0.5rem;
        pointer-events: none;
        font-weight: bold;
        text-shadow: none;
      }

      .hint {
        position: absolute;
        color: transparent;
        line-height: 1.25em;
        text-align: center;
        top: 50%;
        // margin-right: 6%;
        padding: 10px 12px;
        transform: translate(-80%, -50%);
        pointer-events: none;
        text-shadow: none;
        width: 11rem;
      }

      &:hover {
        color: var(--secondary-font-color);
        background-color: var(--foreground-color);
        fill: var(--secondary-font-color);

        .hint {
          color: var(--primary-font-color);
          pointer-events: all;
          background-color: var(--seethrough-bg);
        }
      }
    }
  }
}
.collar {
  background-color: var(--foreground-color);
  border-radius: 4px 0px 0px 0px;
  flex: 1 0 55%;
  display: flex;
  color: var(--secondary-font-color);
  height: 100%;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  pointer-events: all;

  .collar-item {
    display: flex;
    width: 50%;
    align-items: flex-start;
    cursor: pointer;
    gap: 0.5em;
    padding: 0 0.5em;
    .img-block {
      flex: 0 0 72px;
      height: 72px;
    }

    .img {
      // padding-bottom: 60%;
      // width: 72px;
      object-fit: cover;
      border-radius: 3px;
      background-color: rgba(var(--secondary-bg), 0.7);
      // margin-right: 1.4rem;
      // margin-left: 1.25rem;
    }

    .collar-sub-cat {
      font-size: 0.875em;
      line-height: 1.6em;
    }

    .collar-title {
      font-weight: 500;
      line-height: 1.4;
    }
  }

  &-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 95px;
    width: 100%;
    display: flex;
    pointer-events: none;
    // transform: translateX(-50%);

    div {
      text-shadow: none;
    }
  }

  &-spacer {
    height: 100%;
    width: 50%;
    pointer-events: none;
  }
}
</style>
